// Service for the student side of Phase 6's Parent Check-In: a parent-sent
// mini quiz, delivered as a soft nudge (never assignment-toned), graded
// deterministically server-side, with no score ever shown to the student.
// Phase 8 port -- RPCs are already student_id-keyed and app-agnostic
// (concept_table already includes 'concepts_plus1'), so this is a
// byte-for-byte copy of rewise-ui's version.

import { supabase } from "./supabaseClient";

export interface PendingCheckinQuestion {
  question: string;
  options: string[];
}

export interface PendingCheckin {
  id: number;
  concept_id: number;
  concept_table: "concepts" | "concepts_plus1";
  concept_name: string;
  subject: string;
  difficulty: "easy" | "medium" | "hard";
  questions_json: { question: string; options: string[] }[];
  created_at: string;
}

export async function getPendingCheckins(studentId: string): Promise<PendingCheckin[]> {
  try {
    const { data, error } = await supabase.rpc("get_student_pending_checkins", { p_student_id: studentId });
    if (error) {
      console.error("Error fetching pending check-ins:", error);
      return [];
    }
    return (data || []) as PendingCheckin[];
  } catch (err) {
    console.error("Exception fetching pending check-ins:", err);
    return [];
  }
}

interface SubmitCheckinResult {
  success: boolean;
  qualitative_state?: "comfortable" | "worth_review";
  qualitative_headline?: string;
  error?: string;
}

export async function submitCheckinResult(params: {
  checkinId: number;
  studentId: string;
  answers: { question_index: number; option_chosen: number }[];
  timeTakenSeconds: number;
}): Promise<SubmitCheckinResult> {
  try {
    const { data, error } = await supabase.rpc("submit_checkin_result", {
      p_checkin_id: params.checkinId,
      p_student_id: params.studentId,
      p_answers: params.answers,
      p_time_taken_seconds: params.timeTakenSeconds,
    });
    if (error) {
      console.error("Error submitting check-in result:", error);
      return { success: false, error: "Something went wrong — try again." };
    }
    return data as SubmitCheckinResult;
  } catch (err) {
    console.error("Exception submitting check-in result:", err);
    return { success: false, error: "Something went wrong — try again." };
  }
}
